import { formatDate } from './dateUtilities.js';

const todoIsOverdue = (todo) => {
  const formattedDate = new Date(formatDate(todo.target_datetime));
  const isOutdated = formattedDate - new Date() < 0;
  const isActive = todo.todo_status === '1';
  return isActive && isOutdated;
};

export default todoIsOverdue;
